import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import auth from '../../utils/auth';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const response = await auth.requestPasswordReset(email);
      
      if (response.success) {
        setSuccess(true);
      } else {
        setError(response.error || 'Failed to request password reset');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError(
        err.error || 
        err.response?.data?.error || 
        err.message || 
        'Failed to request password reset'
      );
    }
    
    setIsLoading(false);
  };

  return (
    <>
      <h4 className="mb-1">Forgot Password? 🔒</h4>
      <p className="mb-6">Enter your email and we'll send you instructions to reset your password</p>
      
      {success ? (
        <div className="alert alert-success mb-4">
          <p>Password reset code has been sent to your email address.</p>
          <p className="mt-4">
            <Link to="/reset-password" className="btn btn-primary">
              Continue to Reset Password
            </Link>
          </p>
        </div>
      ) : (
        <form id="formForgotPassword" className="mb-6" onSubmit={handleSubmit}>
          {error && <div className="alert alert-danger mb-4">{error}</div>}
          
          <div className="mb-6 form-control-validation">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
          </div>
          
          <button 
            className="btn btn-primary d-grid w-100" 
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
      )}

      <p className="text-center">
        <Link to="/login">
          <i className="icon-base ti tabler-arrow-left"></i> Back to login
        </Link>
      </p>
    </>
  );
};

export default ForgotPassword;